import React, { Component, Fragment } from 'react'
import { ApiHelper } from '../../helpers/ApiHelper';
import { css, StyleSheet } from 'aphrodite';
import { AppStyles, AppTheme } from '../../../styles/AppTheme';
import { SEStyles } from './SEStyles';
import { Grid, Card, CardContent, CardActionArea, Tooltip, Paper, Button } from '@material-ui/core';
import Accordion from '@material-ui/core/ExpansionPanel';
import AccordionSummary from '@material-ui/core/ExpansionPanelSummary';
import AccordionDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Link } from 'react-router-dom';
import { Helper } from '../../helpers/Helper';
import { AppHelper } from '../../../helpers/AppHelper';
import { CustomSEStyles } from '../../../styles/CustomStyles';
import { AppConfig } from '../../../AppConfig';
import { AppButton } from '../AppButton';

export class SubEntityCard extends Component {
  constructor(props) {
    super(props)
    this.fields = this.props.formDefinition.steps[0].fields
  }

  render() {
    const fields = this.generateFields()
    const mainFields = [];
    const advancedFields = [];
    if (this.props.advancedView) {
      this.classifyFields(fields, mainFields, advancedFields)
    }

    return (
      <div className={css(Styles.container)}>
        <div className={css(Styles.heading)}>
          <div className={css(Styles.headingContent)}>
            <h2 className={css(Styles.stepFormTitle)}>{this.props.title}</h2>
            {!this.props.noEdit &&
              <AppButton
                onClick={() => this.props.openModalForEdit(this.props.item)}
                buttonText={'Edit'}
                buttonStyle={Styles.editButton}
                buttonTextStyle={Styles.buttonText} />
            }
          </div>
        </div>
        <div className={this.props.renderFieldsRowwise ? css([Styles.content, Styles.contentForRow]) : css(Styles.content)}>
          {this.props.advancedView ? this.generateContent(mainFields) : this.generateContent(fields)}
        </div>
        {(this.props.advancedView && advancedFields.length > 0) && this.generateAdvancedContent(advancedFields)}
      </div>
    )
  }

  labelDisplay(item, fields) {
    return (<div className={css(Styles.fieldActionsContainer)}>
      <p className={css(Styles.label)}>{item.label}</p>
      {this.props.displayFieldActions && this.props.displayFieldActions(item, fields)}
    </div>)
  }

  valueDisplay(item) {
    // const valueMultiDisplayStyle = [Styles.value, Styles.valueDisplayMultiline]
    // const valueDisplayStyle = fields.length === 1 ? [Styles.value, Styles.valueDisplayMultiline] : Styles.value
    const valueMultiDisplayStyle = this.props.valueStyle ? [...Styles.value, ...this.props.valueStyle] : [Styles.value]
    const valueDisplayStyle = [Styles.value]

    const value = item.valueDisplay || item.resolvedValue || item.value

    if (item.html) {
      return <div className='content'
        dangerouslySetInnerHTML={{ __html: value }} />
    }
    if (item.multiline) {
      return <div className={css(Styles.valueContainer)}><p className={css(valueMultiDisplayStyle)}>{value}</p></div>
    }
    if (item.imageUpload && item.link) {
      return <div className={css(Styles.imageContainer)}><img src={item.link} className={css(Styles.imageContent)} /></div>
    }
    if (item.documentUpload && item.link) {
      return <div className={css(Styles.valueContainer)}><a href={item.link} target='_blank' className={css([valueDisplayStyle, Styles.link])}>{Helper.getString('openFile')}</a></div>
    }
    else {
      return <div className={css(Styles.valueContainer)}><p className={css(valueDisplayStyle)}>{value || '[Not set]'}</p></div>
    }

  }
  isValidField(field) {
    let isValid = true
    if (field.hidden) {
      isValid = false
    }
    if (this.isMobileView) {
      if ((field.value === '') || (Array.isArray(field.value) && field.value.length === 0)) {
        isValid = false
      }
    }
    return isValid
  }

  generateFields() {
    const fields = []
    for (const current of this.fields) {
      const field = {
        id: current.key,
        label: current.label,
        value: this.props.item[current.key],
        advanced: current.advanced
      }
      if (field.value && current.valueDisplayScale) {
        field.value = (field.value / current.valueDisplayScale).toFixed(2)
      }
      if (current.html) {
        field.html = true
      }
      if (current.multiline) {
        field.multiline = true
      }
      if (current.imageUpload && current.linkName) { //retained for backward compatibility
        field.subType = 'image'
        field.link = this.props.item[current.linkName]
      }
      if (current.subType === 'image' && current.linkName) {
        field.subType = 'image'
        field.link = this.props.item[current.linkName]
      }
      if (current.documentUpload && current.linkName) { //retained for backward compatibility
        field.subType = 'document'
        field.link = this.props.item[current.linkName]
      }
      if (current.subType === 'document' && current.linkName) {
        field.subType = 'document'
        field.link = this.props.item[current.linkName]
      }
      if (current.colourPicker) { //retained for backward compatibility
        field.subType = 'colour'
      }
      if (current.subType === 'colour') {
        field.subType = 'colour'
      }
      if (current.subType === 'hyperlink') {
        field.subType = 'hyperlink'
      }
      if (current.hidden) {
        field.hidden = true
      }
      if (current.options) {
        field.options = current.options
      }
      switch (current.type) {
        case 'edit_text':
          break
        case 'rich_text':
          field.valueDisplay = 'YES'
          break
        case 'dateTime':
          if (!field.value) continue
          field.valueDisplay = Helper.formatTimestamp(field.value)
          break
        case 'radio':
        case 'check_box':
        case 'select':
          console.log('radio/check_box/select:', field, current)
          if (field.value && current.options) {
            const optionsByKey = {}
            current.options.forEach(i => optionsByKey[i.key] = i)
            let valuesToResolve = field.value
            if (!Array.isArray(valuesToResolve)) {
              valuesToResolve = [valuesToResolve]
            }
            const resolvedValues = []
            valuesToResolve.forEach(i => optionsByKey[i] ? resolvedValues.push(optionsByKey[i].text) : 'UNK')
            field.resolvedValue = resolvedValues.join(', ')
          }
          break
        default:
          continue
      }
      if (!current.placement) {
        current.placement = 'left' // default
      }
      if (!(current.key in this.props.item)) {
        continue
      }
      if (current.placement === 'left') {
        fields.push(field)
      } else if (current.placement === 'right') {
        fields.push(field)
      }
    }
    return fields
  }
  classifyFields(fields, mainFields, advancedFields) {
    for (const field of fields) {
      if (field.advanced) {
        advancedFields.push(field);
      } else {
        mainFields.push(field);
      }
    }
  }

  generateContent(fields) {
    return (<Fragment>
      {fields.filter((field) => this.isValidField(field)).map((item, index) => {
        return (
          <Fragment>
            <div key={item.label} className={this.props.renderFieldsRowwise ? css([Styles.labelContainer, Styles.labelContainerForRow]) : css(Styles.labelContainer)}>
              {this.labelDisplay(item, fields)}
              {this.valueDisplay(item)}
            </div>
            {this.props.renderFieldsRowwise && index % 2 === 0 && <div className={css(Styles.dividerForRow)} />}
          </Fragment>
        )
      })}
    </Fragment>)
  }

  generateAdvancedContent(advancedFields) {
    return (<div className={css(Styles.content, Styles.accordionContainer)}>
      <Accordion
        elevation={0}
        className={css(Styles.accordion)}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon className={css(Styles.accordionIcon)} />}
          classes={{ expandIcon: css(Styles.accordionExpandIcon) }}
          className={css(Styles.accordionSummary)}
        >
          <Typography className={css(Styles.advancedTitle)}>Advanced</Typography>
        </AccordionSummary>
        <AccordionDetails className={this.props.renderFieldsRowwise ? css([Styles.content, Styles.contentForRow, Styles.accordionDetails]) : css(Styles.content)}>
          {this.generateContent(advancedFields)}
        </AccordionDetails>
      </Accordion>
    </div>)
  }
}

const Styles = (AppConfig.CUSTOM_STYLE || AppConfig.CUSTOM_STYLE_COMP.includes('SubEntityCard')) ? CustomSEStyles : SEStyles



// WEBPACK FOOTER //
// ./src/common/components/SubEntity/SubEntityCard.js